/* eslint-disable react/prop-types */
function Plus({className, fill = "currentColor", stroke = "#000000"}) {
  return (
    <svg className={className} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 18 18">
      <path stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 1v16M1 9h16"/>
    </svg>
  )
}

export default Plus